import { render, staticRenderFns } from "./CourtArbitrationAdd.vue?vue&type=template&id=78fae44c&scoped=true&"
import script from "./CourtArbitrationAdd.vue?vue&type=script&lang=js&"
export * from "./CourtArbitrationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fae44c",
  null
  
)

export default component.exports